/**
 * The pitch drawn behind the weekly quests (specs/home-page AC-22 revised): the "Home Final" design's
 * 180×228 markings, stretched to the card. Vector, so it scales with the card and ships no raster.
 */

import React from 'react';
import type { StyleProp, ViewStyle } from 'react-native';
import Svg, { Rect, Line, Circle } from 'react-native-svg';

const STRIPE = 'rgba(255, 255, 255, 0.05)';
const LINE = 'rgba(255, 255, 255, 0.32)';
const LINE_WIDTH = 1.5;

export interface WeeklyPitchBackgroundProps {
  style: StyleProp<ViewStyle>;
  testID?: string;
}

export const WeeklyPitchBackground: React.FC<WeeklyPitchBackgroundProps> = ({ style, testID }) => (
  <Svg viewBox="0 0 180 228" preserveAspectRatio="none" style={style} pointerEvents="none" testID={testID}>
    <Rect x={0} y={0} width={180} height={38} fill={STRIPE} />
    <Rect x={0} y={76} width={180} height={38} fill={STRIPE} />
    <Rect x={0} y={152} width={180} height={38} fill={STRIPE} />
    <Rect x={8} y={8} width={164} height={212} rx={2} fill="none" stroke={LINE} strokeWidth={LINE_WIDTH} />
    <Line x1={8} y1={114} x2={172} y2={114} stroke={LINE} strokeWidth={LINE_WIDTH} />
    <Circle cx={90} cy={114} r={20} fill="none" stroke={LINE} strokeWidth={LINE_WIDTH} />
    <Rect x={48} y={8} width={84} height={34} fill="none" stroke={LINE} strokeWidth={LINE_WIDTH} />
    <Rect x={66} y={8} width={48} height={13} fill="none" stroke={LINE} strokeWidth={LINE_WIDTH} />
    <Rect x={48} y={186} width={84} height={34} fill="none" stroke={LINE} strokeWidth={LINE_WIDTH} />
    <Rect x={66} y={207} width={48} height={13} fill="none" stroke={LINE} strokeWidth={LINE_WIDTH} />
  </Svg>
);
